module.exports = __webpack_public_path__ + "img/kissing_smiling_eyes.80107daa.png";